export default "__VITE_ASSET__BUcBiG0W__"